import React, { useContext } from "react";

import { Modal, Button } from "rsuite";
import { isFunction } from "lodash";

import { changeLog } from ".";
import { generateGuid } from "../utils";
import { translate, checkAndTranslate } from "../languages";
import { useIntl } from 'react-intl';

import { SiteContext } from "../context";

function ChangeLogModal(props) {
  const {
    onClose
  } = props;

  const intl     = useIntl();
  const { site } = useContext(SiteContext);

  const latestViewedChangelogVersion = localStorage.getItem("latestViewedChangelogVersion");
  const latestChangelogVersion = changeLog?.[0]?.version;

  /**
   * Handles closing of the changelog modal. Calls onClose
   * function (received from parent) if applicable.
   */
  function handleClose() {
    localStorage.setItem("latestViewedChangelogVersion", latestChangelogVersion);
    if (isFunction(onClose)) {
      onClose();
    }
  }

  /**
   * Constructs and returns a header string for a single
   * changelog entry in the changelog display.
   * @param {Object} entry a single Object entry in changelog
   * @returns {string} header string for changelog display
   */
  function getHeader(entry) {
    let header = entry.version;
    if (entry.date) {
      header += ` --- ${entry.date}`;
    }
    return header;
  }

// This code will work when user manual is ready, entry.readMore can be changed to this
//   <Link 
//      to={{
//        pathname: `/${site}/confluence`,
//        hash: entry.readMore //e.g. '#Panel-features_1269792856.html'
//      }}
//      style={{ cursor: "pointer" }}
//    >
//      <i className="fas fa-info-circle fa-lg" />
//    </Link>

  /**
   * Constructs changelog content by looping through
   * changelog Array.
   * @returns {JSX.Element} content of changelog
   */
  function parseContent() {
    let hitLatestViewedChangelogVersion = false;
    return (
      <div data-testid="changelog-main-div">
        {
          changeLog.map(entry => { // map each version number

            // give entries a different class until
            // first already seen entry comes across
            if (entry.version === latestViewedChangelogVersion) {
              hitLatestViewedChangelogVersion = true;
            }
            return (
              <React.Fragment key={`changelog-${generateGuid()}`}>
                <div
                  className={hitLatestViewedChangelogVersion ? "changelog-entry changelog-read" : "changelog-entry changelog-unread"}
                  key={`changelog-${generateGuid()}`}
                >
                  <div 
                    style={{ 
                      display: 'flex', 
                      justifyContent: 'space-between', 
                      alignItems: 'center' 
                    }}
                  >
                    <h4>
                      {getHeader(entry)}
                    </h4>
                    {entry.readMore && 
                      <i 
                        className="fas fa-info-circle fa-lg" 
                        style={{cursor: "pointer"}} 
                        onClick={() => window.open(`/boa/api/v1/updateInfo/${entry.version}`, "_blank")}
                      />
                    }
                    {entry.userManual && site &&
                      <i 
                        className="fas fa-info-circle fa-lg" 
                        style={{cursor: "pointer"}} 
                        onClick={() => window.location.href = `/boa/${site}/user_manual#${entry.userManual}` }
                      />
                    }
                  </div>
                  <ul>
                    {
                      entry.description.map((description) => { // map each description
                        return (
                          <li key={`changelog-${generateGuid()}`}>
                            {checkAndTranslate(description, intl)}
                          </li>
                        )
                      })
                    }
                  </ul>
                </div>
                <hr key={`changelog-${generateGuid()}`} />
              </React.Fragment>
            );
          })
        }
      </div>
    );
  }

  return( 
    <React.Fragment>
      <Modal.Header>
        <h3>
          {translate("Changelog")}
        </h3>
      </Modal.Header>

      <Modal.Body>
        <div>
          {parseContent()}
        </div>
      </Modal.Body>

      <Modal.Footer>

      <Button
          data-testid="changelog-close-button"
          onClick={handleClose}
          appearance="primary" 
          color="red"
          style={{marginTop: "10px"}}
          > {translate("Close")}
        </Button>
      </Modal.Footer>
    </React.Fragment>
  );
}

export default ChangeLogModal;
